import React from 'react';
import { withTranslation, WithTranslation } from '@wix/wix-i18n-config';
import s from './PackageFree.scss';
import classnames from 'classnames';

export interface PackageFreeProps extends WithTranslation {
  isTaxShown: boolean;
  isSaleOn: boolean;
}

class PackageFree extends React.Component<PackageFreeProps> {
  render() {
    const { t, isTaxShown, isSaleOn } = this.props;

    return (
      <div className={s.root} data-hook="packageFree">
        <div
          className={classnames(s.price, {
            [s.saleOn]: isSaleOn,
          })}
          data-hook="packageFree-price"
        >
          {t('package.free.price')}
        </div>
        <div className={s.bottom}>
          {isTaxShown && <div className={s.taxHeightCompensation} />}
          <div className={s.preInstalled} data-hook="packageFree-preInstalled">
            {t('package.free.preInstalled')}
          </div>
          <div className={s.description} data-hook="packageFree-description">
            {t('package.free.description')}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(PackageFree);
